import { InjectionToken } from "@angular/core";
import { TreasuryBankAccountsPort } from "./bank-accounts.port";

export const TREASURY_BANK_ACCOUNTS_PORT =
  new InjectionToken<TreasuryBankAccountsPort>("TREASURY_BANK_ACCOUNTS_PORT");
